/**
 * 本文件由 scripts/generate-spm-codes.mjs 生成，请勿手改；编码以评审确认后的 CSV 快照为准。
 * 全局终端：global_app（由 CSV 页面终端行派生，B 位重写为 global_app；200 个 D 位坑位，8 个 C 位模块）。
 * 数据源：global_wap（全量派生）。
 * 模块级曝光上报 module.code（A.B.C）；坑位级曝光与点击上报完整编码（A.B.C.D）。
 */
import type { SpmPageCodes } from '../types';
import { getSpmSitePrefix } from '../site';

const sitePrefix = getSpmSitePrefix();

export const GLOBAL_APP_SPM_CODES = {
  footer_app: {
    code: `${sitePrefix}.global_app.footer_app`,
    download_android_app: `${sitePrefix}.global_app.footer_app.download_android_app`,
    open_download_on_the_app_store: `${sitePrefix}.global_app.footer_app.open_download_on_the_app_store`,
  },
  footer_help: {
    code: `${sitePrefix}.global_app.footer_help`,
    open_help_center: `${sitePrefix}.global_app.footer_help.open_help_center`,
    open_order_tracking: `${sitePrefix}.global_app.footer_help.open_order_tracking`,
  },
  footer_navigation: {
    code: `${sitePrefix}.global_app.footer_navigation`,
    'footer_group_toggle_{NN}': `${sitePrefix}.global_app.footer_navigation.footer_group_toggle_{NN}`,
    'footer_link_{NN}': `${sitePrefix}.global_app.footer_navigation.footer_link_{NN}`,
  },
  footer_social: {
    code: `${sitePrefix}.global_app.footer_social`,
    'social_entry_{NN}': `${sitePrefix}.global_app.footer_social.social_entry_{NN}`,
  },
  footer_subscribe: {
    code: `${sitePrefix}.global_app.footer_subscribe`,
    email_input: `${sitePrefix}.global_app.footer_subscribe.email_input`,
    submit_subscription: `${sitePrefix}.global_app.footer_subscribe.submit_subscription`,
  },
  header_tools: {
    code: `${sitePrefix}.global_app.header_tools`,
    cart_entry: `${sitePrefix}.global_app.header_tools.cart_entry`,
    logo_entry: `${sitePrefix}.global_app.header_tools.logo_entry`,
    open_account: `${sitePrefix}.global_app.header_tools.open_account`,
    open_search: `${sitePrefix}.global_app.header_tools.open_search`,
    toggle_navigation: `${sitePrefix}.global_app.header_tools.toggle_navigation`,
  },
  mobile_navigation: {
    code: `${sitePrefix}.global_app.mobile_navigation`,
    'nav_item_{NN}': `${sitePrefix}.global_app.mobile_navigation.nav_item_{NN}`,
    open_contact_us: `${sitePrefix}.global_app.mobile_navigation.open_contact_us`,
    open_help_center: `${sitePrefix}.global_app.mobile_navigation.open_help_center`,
    open_order_tracking: `${sitePrefix}.global_app.mobile_navigation.open_order_tracking`,
    site_settings_entry: `${sitePrefix}.global_app.mobile_navigation.site_settings_entry`,
    'social_entry_{NN}': `${sitePrefix}.global_app.mobile_navigation.social_entry_{NN}`,
    'submenu_item_{NN}_{NN}': `${sitePrefix}.global_app.mobile_navigation.submenu_item_{NN}_{NN}`,
  },
  site_notice: {
    code: `${sitePrefix}.global_app.site_notice`,
    open_promotion: `${sitePrefix}.global_app.site_notice.open_promotion`,
  },
} as const satisfies SpmPageCodes;
